<template>
    <div class="slider_box">
        <div class="verification">
            <span class="verification-span">请完成安全验证</span>
            <i class="el-icon-close" @click="offVerify"></i>
        </div>
        <div class="slide_img_content">
            <div class="slide_img">
                <img class="slide_refresh" src="../../assets/images/refresh.png"
                    @click="uploadSlideVerificationCode();" />
                <img id="cutImage" class="slide_img_mark" ref="cutImage" />
                <img id="originalImage" ref="originalImage" style="width: 100%;" />
            </div>
        </div>
        <div class="slider_clear">
            <div class="slider">
                <div class="slider_arror" ref="slider_arror" style="cursor:pointer;" onselectstart="return false;">
                    <img style="margin-top: 5px;" id="arror_icon" src="../../assets/images/arrow-right-circle.png"
                        draggable="false" width="30px" height="30px" ref="arror_icon" />
                </div>
                <div class="slider_mask" ref="slider_mask"></div>
                <span class="slider_tip" onselectstart="return false;" ref="slider_tip">向右拖动滑块填充拼图</span>
            </div>
        </div>
        <p id="slideVerificationCodeError" style="font-weight:bold" ref="slideVerificationCodeError"></p>
    </div>
</template>

<script>
// https://zhuanlan.zhihu.com/p/556438979
export default {
    name: "slider",
    data() {
        return {
            success: true,
            successVerifyTime: null,
            uploadSlideVerificationCodeTime: null,
            sliderStart: false,
            x_slider: null,// 鼠标最初位置
            y_slider: null,// 鼠标最初位置
            original_image_with_slider: 300,//边界宽度 = 图片宽度
            cut_image_width_slider: 50,//剪切图宽度
            yLocation: null,// 数据返回 x y
            //图片显示使用base64时的前缀,src=base64PrefixPathSlide + imgBase64Value
            base64PrefixPathSlide: "data:image/png;base64,",
             //线上环境
            // baseURL: 'https://open.baiwang.com/defense',
            //测试环境
            baseURL: '/api/defense',
            unixId: null,
        }
    },
    created() {

    },
    beforeDestroy() {
        // 移除事件监听
        this.$refs.arror_icon.removeEventListener("mousedown", this.handleStart);
        this.$refs.arror_icon.removeEventListener("touchstart", this.handleStart);
        document.removeEventListener("mousemove", this.handleMove);
        document.removeEventListener("touchmove", this.handleMove);
        document.removeEventListener("mouseup", this.handleEnd);
        document.removeEventListener("touchend", this.handleEnd);
    },
    methods: {
        offVerify() {
            this.$emit("offMask")
        },

        uploadSlideVerificationCode() {
            this.resetSlide(); //拼图验证码用---修改位置和重置颜色
            const url = this.baseURL + "/getData"

            this.$http.post(url)
                .then((res) => {
                    if (res.rspCode !== "000000" || !res.data) {
                        return
                    }
                    const cutImage = res.data.cutImage
                    const bgimgurl = res.data.srcImage
                    this.yLocation = res.data.locationY;
                    this.unixId = "" + res.data.token
                    this.initImgSlide(bgimgurl, cutImage, this.yLocation);
                    this.initMovementSlide();
                    this.$refs.slideVerificationCodeError.innerText = ""
                })


            // slideVerificationCode().then(jsonData => {
            //     if (jsonData.data.code == 0) {
            //         var data = JSON.parse(jsonData.data.data);
            //         this.yLocation = data.yLocation;
            //         this.initImgSlide(data.originalImage, data.cutImage, this.yLocation);
            //         this.initMovementSlide();
            //         this.$refs.slideVerificationCodeError.innerText = ""
            //     }
            // });
        },

        //图片显示使用base64时的前缀,src=base64PrefixPathSlide + imgBase64Value
        // var base64PrefixPathSlide = "data:image/png;base64,";
        // 拼图验证码用---初始化图片
        initImgSlide(originalImage, cutImage, yLocation) {
            this.$refs.originalImage.src = this.base64PrefixPathSlide + originalImage
            this.$refs.cutImage.src = this.base64PrefixPathSlide + cutImage
            this.$refs.cutImage.style.marginTop = yLocation + 'px'
            this.$refs.cutImage.style.width = '70px'
            this.$refs.cutImage.style.height = '70px'
        },

        // 拼图验证码用---设置回调
        initMovementSlide() {
            // 鼠标事件
            this.$refs.arror_icon.addEventListener("mousedown", this.handleStart);
            document.addEventListener("mousemove", this.handleMove);
            document.addEventListener("mouseup", this.handleEnd);
            
            // 触摸事件
            this.$refs.arror_icon.addEventListener("touchstart", this.handleStart, { passive: false });
            document.addEventListener("touchmove", this.handleMove, { passive: false });
            document.addEventListener("touchend", this.handleEnd);
        },
        // 按下滑动按钮,统一处理开始事件（鼠标和触摸）
        handleStart(e) {
            e.preventDefault(); // 防止触摸时页面滚动
            this.sliderStart = true;
            
            // 统一处理客户端坐标
            const clientX = e.clientX || (e.touches && e.touches[0].clientX);
            const clientY = e.clientY || (e.touches && e.touches[0].clientY);
            
            if (clientX === undefined) return;
            
            this.x_slider = clientX;
            this.y_slider = clientY;
            this.$refs.slider_tip.style.display = "none";
            this.$refs.slider_mask.style.backgroundColor = "#deee97";
            this.$refs.arror_icon.src = require("../../assets/images/arrow-right-circle.png");
        },
        // 统一处理移动事件（鼠标和触摸）
        handleMove(e) {
            if (!this.sliderStart) return false;
            e.preventDefault(); // 防止触摸时页面滚动
            
            // 统一处理客户端坐标
            const eventX = e.clientX || (e.touches && e.touches[0].clientX);
            // const eventY = e.clientY || (e.touches && e.touches[0].clientY);
            
            if (eventX === undefined) return;
            
            const moveX = eventX - this.x_slider;
            
            // 确保边界
            if (
                moveX < 0 ||
                moveX + parseInt(this.cut_image_width_slider) > this.original_image_with_slider
            ) {
                return false;
            }
    
            // 改变slider_arror的位置和mask大小
            this.$refs.slider_arror.style.marginLeft = moveX + "px";
            this.$refs.slider_arror.style.cursor = "pointer";
            this.$refs.slider_mask.style.width = moveX + "px";
            this.$refs.cutImage.style.marginLeft = moveX + "px";
        },
    
        // 统一处理结束事件（鼠标和触摸）
        handleEnd(e) {
            if (!this.sliderStart) return false;
            this.sliderStart = false;
            
            const slideImgMark = document.getElementById("cutImage");
            var slideX = slideImgMark.style.marginLeft;
            slideX = slideX.toString().slice(0, -2);
            var tip = this.$refs.slideVerificationCodeError;
    
            const url = this.baseURL + "/verify?unixId=" + this.unixId + "&xAxis=" + slideX;
            this.$http.get(url)
                .then((res) => {
                    if (res.rspCode === "000000") {
                        tip.color = "green";
                        tip.innerText = "恭喜你，滑动验证码正确";
                        this.successSlide();
                    } else {
                        tip.color = "red";
                        tip.innerText = "滑动验证码错误，请重新滑动";
                        this.failedSlide();
                    }
                });
        },

        // 拼图验证码用---验证成功回调方法
        successSlide() {
            this.$refs.arror_icon.src = require("../../assets/images/zhengque-correct.png")
            this.$refs.slider_mask.style.backgroundColor = "#79e77e"
            //移除一系列鼠标事件
            this.$refs.arror_icon.removeEventListener("mousedown", this.sliderPush);
            document.removeEventListener("mousemove", this.sliderDrug);
            document.removeEventListener("mouseup", this.sliderEnd);

            //验证成功后隐藏验证框
            clearTimeout(this.successVerifyTime)
            this.successVerifyTime = null
            this.successVerifyTime = setTimeout(() => {
                this.$emit("successVerify", this.success);
            }, 500);
        },

        // 拼图验证码用---失败重置
        failedSlide() {
            this.$refs.arror_icon.src = require("../../assets/images/MPIS-Error.png")
            this.$refs.slider_mask.style.backgroundColor = "#e73c4a"
            clearTimeout(this.uploadSlideVerificationCodeTime)
            this.uploadSlideVerificationCodeTime = null
            this.uploadSlideVerificationCodeTime = setTimeout(this.uploadSlideVerificationCode, 1000);
        },

        // 拼图验证码用---修改位置和重置颜色
        resetSlide() {
            this.$refs.slider_mask.style.backgroundColor = "#deee97"
            this.$refs.slider_arror.style.marginLeft = 0
            this.$refs.slider_arror.style.cursor = "pointer"
            this.$refs.slider_mask.style.width = 0
            const slideImgMark = document.getElementById("cutImage")
            slideImgMark.style.marginLeft = 0;
            this.$refs.arror_icon.src = require("../../assets/images/arrow-right-circle.png")
            this.$refs.slider_tip.style.display = "block"
            this.$refs.slideVerificationCodeError.innerText = ""
        }

    }
}
</script>

<style lang="less">
.verification {
    margin-bottom: 10px;

    .verification-span {
        padding: 5px;
    }

    .el-icon-close {
        float: right;
        margin: 5px;
    }
}

.slide_img_content {
    position: relative;
    margin: auto;
}

.slide_img {
    width: 280px;
    height: 160px;
    position: relative;
}

.slide_img_mark {
    position: absolute;
    height: 50px;
    width: 50px;
    margin-top: 50px;
    margin-left: 0;
}

.slider {
    float: left;
    margin: 10px auto auto;
    height: 40px;
    width: 280px;
    border: 1px solid #c6cbd1;
    background-color: #f9fbfc;
}

.slider_arror {
    position: absolute;
    margin-left: 0;
    height: 40px;
    width: 50px;
    border-left: 1px solid #252627;
    border-right: 1px solid #252627;
    text-align: center;
}

.slider_arror:hover {
    background-color: #deee97;
}

.slider_mask {
    position: absolute;
    margin-left: 0;
    margin-top: 0;
    width: 0;
    height: 40px;
    background-color: #deee97;
}

.slider_tip {
    position: absolute;
    margin-left: 95px;
    line-height: 40px;
}

.slider_clear:after {
    /*伪元素是行内元素 正常浏览器清除浮动方法*/
    content: '';
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
}

.slider_clear {
    *zoom: 1;
    /*ie6清除浮动的方式 *号只有IE6-IE7执行，其他浏览器不执行*/
}

.slide_refresh {
    width: 30px;
    height: 30px;
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
}
</style>